<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Alterar Classificação Secundária'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Dialog de confirmação -->
                <v-dialog v-model="dialog" width="600">
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      Confirma a alteração da classificação secundária?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="primary" text @click="dialog = false">Não</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="alterarClassificacaoSecundaria">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- Título -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field readonly label="Título do projeto" :value="this.projeto.titulo"></v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Número e situação -->
                <v-layout row>

                  <!-- Número -->
                  <v-flex xs6>
                    <v-text-field readonly label="Número" :value="this.projeto.idProjeto"></v-text-field>
                  </v-flex>

                  <!-- Situação -->
                  <v-flex xs6>
                    <v-text-field readonly label="Situação" :value="this.projeto.situacao.descricao"></v-text-field>
                  </v-flex>

                </v-layout>

                <!-- Classificação Secundária -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm6>
                    <v-select
                      label='Classificação secundária'
                      :items="listaClassificacaoSecundaria"
                      v-model="alteracao.classificacaoSecundaria"
                      item-text="descricao"
                      item-value="id"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="obrigatorio" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

                <!-- Justificativa/Observação -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Justificativa/Observação"
                      v-model="alteracao.justificativaObservacao"
                      :rules="tamanho2000caracteres"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="2000"
                      required
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>
            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Alterar" -->
            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Alterar -->
              <v-btn color="primary" text @click="dialog = true" :disabled="!formularioValido">Alterar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      listaClassificacaoSecundaria: [],
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      alteracao: {
        classificacaoSecundaria: {},
        justificativaObservacao: ''
      },
      obrigatorio: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      tamanho2000caracteres: [
        (input) => input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Cancelar.
      cancelar: function () {
        this.$router.go(-1)
      },
      // Alterar classificação secundária.
      alterarClassificacaoSecundaria: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Alterando classificação secundária...' })
        projetos.postAlterarClassificacaoSecundaria(this.idProjeto, this.alteracao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoFormulario', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Alterando classificação secundária...' })
        })
      },
      // Obtém as classificações.
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
        })
      }
    },
    mounted () {
      // Obtém as classificações secundárias.
      this.obterClassificacoes(91, this, 'listaClassificacaoSecundaria')
      // Carrega o projeto.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.alteracao.classificacaoSecundaria = this.projeto.classificacaoSecundaria
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }

  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// alterar-classificacao-secundaria.vue?1002acf5